/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import AsyncSelectItem from 'components/AsyncSelectItem';
import type { Organization } from './types';

type Props = {
  organization: Organization,
};

class OrganizationPickerItem extends React.Component<Props, $FlowFixMeState> {
  render() {
    const { organization } = this.props;
    const address = [organization.city, organization.state].filter(Boolean).join(', ');

    return (
      <AsyncSelectItem title="we_dont_care">
        <div style={{ padding: '15px' }}>
          <Text align="left" element="div" color="thunder">
            <Text element="div" size="medium" weight="semibold">
              {organization.name}
            </Text>
            <Text element="div" size="xsmall">
              {address}
            </Text>
            <Text element="div" size="xsmall">
              {organization.members_sample_string}
            </Text>
          </Text>
        </div>
      </AsyncSelectItem>
    );
  }
}

export default OrganizationPickerItem;
